import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Shopping Cart',
    component: () => import('../views/ShoppingCart.vue'),
    meta: {
      title: 'Shopping Cart',
    },
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: () => import('../views/Checkout.vue'),
    meta: {
      title: 'Checkout',
    },
  },
  {
    path: '/order-confirmed',
    name: 'Order Confirmed',
    component: () => import('../views/Confirmation.vue'),
    meta: {
      title: 'Order Confirmed',
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
